import { Injectable } from '@angular/core';

import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { SpinnerCoverComponent } from './spinner-cover/spinner-cover.component';

@Injectable({
	providedIn: 'root'
})
export class ProgressIndicatorService {

	private spinnerRef: MatDialogRef<SpinnerCoverComponent, object>;
	private spinnerTimer: any;

	constructor(public dialog: MatDialog) {}

	/**
	 * show/hide the general spinner
	 * @param show boolean
	 * @param timeout defaults to 30 secs
	 */
	public spinner(show: boolean, timeout: number = 30000): void {
		if (show) {
			if (!this.spinnerRef) {
				const dialogConfig = new MatDialogConfig();
				dialogConfig.disableClose = true;
				dialogConfig.autoFocus = true;
				this.spinnerRef = this.dialog.open(SpinnerCoverComponent, dialogConfig);
			}
			this.clearSpinnerTimer();
			this.spinnerTimer = setTimeout(() => {
				this.clearSpinnerTimer();
				if (this.spinnerRef) {
					this.spinnerRef.close();
					this.spinnerRef = null;
				}
			}, timeout);
		} else {
			if (this.spinnerRef) {
				this.spinnerRef.close();
				this.spinnerRef = null;
			}
			this.clearSpinnerTimer();
		}
	}

	public hasSpinner(): boolean {
		return !!this.spinnerTimer;
	}

	/**
	 * remove the timer that auto hides the spinner
	 */
	private clearSpinnerTimer() {
		if (this.spinnerTimer) {
			clearTimeout(this.spinnerTimer);
			this.spinnerTimer = null;
		}
	}
}
